<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-slash'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_booking_block`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addBlockListToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Service" @click="addBlockListToggle = !addBlockListToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add') + $t(`subMenu.salon_setting_booking_block`)}}</span>
            </button>
        </div>
        <div v-if="addBlockListToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add') + $t(`subMenu.salon_setting_booking_block`)}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content pb-5">
                        <blockListForm @submitBlockList="submitBlockList" @returnBlockList="addBlockListToggle = false"></blockListForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> --> 
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter mb-2">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearch">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearch()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2"> 
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table small striped hover bordered :fields="fields" :items="blockListItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(createDate)="data">
                                            {{convertTimestampToDateTime(data.item.createDate)}}
                                        </template>
                                        <template #cell(action)="data">
                                            <a class="link text-primary" @click="deleteBlockList(data.item.blockID, data.item.mobile)">
                                                <i class="fal fa-trash"></i>
                                            </a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal ref="modal" @performConfirmAction="performDeleteAction"></modal>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import Modal from './../../Delete_Modal'
import BlockListForm from './Booking_BlockList_Form'

import moment from 'moment'
import {setReturnData, handleSessionExpired, handleError} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: "bookingBlockList",
    components:{
        BlockListForm, Modal, BreadCrumb
    },
    data: () => ({
        outlet: [], selectedOutlet: {}, search: "", searchFilter: "",
        isSpinnerShow: false, addBlockListToggle: false,
        blockListItems: [],
        sID: '', sMobile: '',
        exportHeaders: [], exportData: [], exportFileName: "",
        page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
        blackListExportData: []
    }),
    computed: {
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "createDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
                {key: "action", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.blackListExportData)
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.addBlockListToggle = false
                this.$refs.modal.toggleModal = false
                this.filterGetBookingBlockList("")
            }
            this.$parent.isModalShow = false;
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24);
        },
        clearFilter(){
            this.searchFilter = this.search = "";
            this.selectedOutlet = this.outlet[0]
            this.filterGetBookingBlockList(this.searchFilter)
        },
        filterByOutlet(item){
            this.selectedOutlet = item
            this.filterGetBookingBlockList(this.searchFilter)
        },
        filterSearch(){
            this.searchFilter = this.search == "" ? "" : "&search=" + this.search;
            this.filterGetBookingBlockList(this.searchFilter)
        },
        async filterGetBookingBlockList(strFilter){
            this.isSpinnerShow = true;
            var bookingList = await this.getBookingBlockList(strFilter);

            var retData = setReturnData(bookingList, bookingList.length, this.page)
            this.blockListItems = retData.result;
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            this.setExportData(bookingList)
        },
        async getBookingBlockList(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?page=" + this.page + strFilter
            const url =  this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.BOOKING + this.$api.BOOKING_BLOCK + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterGetBookingBlockList(this.searchFilter)
            }
        },
        async getExportData(strFilter){
            let $vm = this;
            const url =  this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.BOOKING + this.$api.BOOKING_BLOCK + strFilter;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.blackListExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t('sideNav.navSalonSetting') + " - " + this.$i18n.t(`subMenu.salon_setting_booking_block`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    date: this.convertTimestampToDateTime(data[i].createDate),
                    mobile: data[i].mobile,
                })
            }
        },
        deleteBlockList(blockID, mobile){
            this.sID = blockID
            this.sMobile = mobile
            
            var title = this.$i18n.t('header.delete', {'item': this.$i18n.t('subMenu.salon_setting_booking_block')})
            var message = this.$i18n.t('message.confirmation.booking_blackList', {'item': mobile})
            this.$refs.modal.showModal(title, message)

        },
        performDeleteAction(){
            let $vm = this
            let QUERY_STRING = "/" + this.sID + this.$api.DELETE
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.BOOKING + this.$api.BOOKING_BLOCK + QUERY_STRING;
            
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = '"' + $vm.sMobile + '"' + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.remove')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        submitBlockList(data){
            let $vm = this
            const url = this.$api.OUTLET + "/" + data.outletID + this.$api.BOOKING + this.$api.BOOKING_BLOCK
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: {mobile: data.mobile}
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data[0];
                    var message = '"' + retData.mobile + '"' + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    this.$parent.setModal(this, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    this.$parent.setModal(this, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];

        $vm.filterGetBookingBlockList("")
    },
}
</script>
<style scoped>
.show{
    display: block;
}
</style>